import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

function PanelList({ panels, selected, setSelected }) {
  const handleSelectRow = (row) => (e) => {
    e.preventDefault();
    setSelected(row);
  };
  return (
    <div className="relative flex-grow">
      <div className="absolute h-full w-full top-0 left-0 overflow-auto">
        <nav className="h-full overflow-y-auto bg-white" aria-label="List">
          <ul className="relative z-0 divide-y divide-gray-100">
            {panels.map((row) => (
              <li key={row.id} className="bg-white">
                <div
                  className={cn(
                    'side-list',
                    selected?.id === row?.id ? 'active' : 'hover:bg-gray-50'
                  )}
                >
                  <div
                    className="absolute left-0"
                    style={{ top: '-30px', height: 'calc(100% + 30px)' }}
                  />
                  {/* <div className="flex-shrink-0">
                    <ThumbIcon
                      className="h-10 w-10 rounded-lg"
                      url={row[photoKey]}
                      alt={row.name}
                    />
                  </div> */}
                  <div className="flex-1 min-w-0">
                    <a
                      href="/"
                      className="focus:outline-none"
                      onClick={handleSelectRow(row)}
                    >
                      {/* Extend touch target to entire panel */}
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-sm font-medium text-gray-900">
                        {row.label}
                      </p>
                      <p className="text-sm text-gray-500 truncate">
                        {row.type}
                      </p>
                    </a>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

PanelList.defaultProps = {
  selected: null,
};

PanelList.propTypes = {
  panels: PropTypes.instanceOf(Array).isRequired,
  selected: PropTypes.instanceOf(Object),
  setSelected: PropTypes.func.isRequired,
};

export default PanelList;
